import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-24" data-id="element-16" data-mp="pjpxnuaidp99">
      <div className="mx-auto max-w-5xl" data-id="element-17" data-mp="pm29rqtl55ee">
        <h2 className="text-center font-serif text-[2.5rem] leading-[1.06] text-sage-800 sm:text-5xl lg:text-[3.5rem]" data-id="element-18" data-mp="avl8q8kv4hi1">
          Plus, today only, these{' '}
          <span className="font-bold text-terracotta-500" data-id="element-19" data-mp="frtl5e7odwli">FREE BONUSES</span>
        </h2>

        <div className="mt-16 space-y-10 lg:space-y-14" data-id="element-20" data-mp="1whrzb964e6p">
          {bonuses.map((bonus, index) => {
          const imageFirst = index % 2 === 0;
          return <article key={bonus.title} className="grid items-center gap-6 rounded-4xl border border-gold-200/50 bg-bone p-6 sm:p-8 lg:grid-cols-2 lg:gap-12 lg:p-10" data-id="element-21" data-mp="3o2wrrfwv81m6" data-mpi={index}>
                <div className={`rounded-3xl bg-cream p-6 sm:p-9 ${imageFirst ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-22" data-mp="1mb1kdchn6j9r">
                  <img src={bonus.image} alt={`${bonus.title} — included resource`} className="mx-auto w-full max-w-[260px] drop-shadow-[0_22px_36px_rgba(56,52,44,0.2)]" data-id="element-23" data-mp="3icvddfc7wq3i" />
                </div>

                <div className={imageFirst ? 'lg:order-2' : 'lg:order-1'} data-id="element-24" data-mp="3n4wnaulwy4qd">
                  <div className="flex flex-wrap items-center gap-3" data-id="element-25" data-mp="2zfao475jjpid">
                    <span className="rounded-full bg-sage-700 px-3.5 py-1 text-[10.5px] font-semibold uppercase tracking-[0.16em] text-cream" data-id="element-26" data-mp="2zhoh8agnurna">
                      Bonus {bonus.index}
                    </span>
                    <span className="text-[12px] font-medium text-ink-light line-through" data-id="element-27" data-mp="38dw4pwrgcugi">
                      {bonus.value}
                    </span>
                  </div>
                  <h3 className="mt-4 font-serif text-[1.7rem] leading-tight text-sage-800 sm:text-[2.1rem]" data-id="element-28" data-mp="no6q9kunvaoc">
                    {bonus.title}
                  </h3>
                  <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-29" data-mp="3chv41muq56l2">
                    {bonus.body}
                  </p>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}